/**
 * 基础信息接口
 */
import { createAxios } from '@/utils/request'

const request = createAxios()
const basePrefix = process.env.VUE_APP_URL_BASE
const urlPrefix = process.env.VUE_APP_URL_API
const urlPrefixIraq = process.env.VUE_APP_URL_IRAQ

// *************************业务类型 start***********************************

// 业务列表
export const getApplicationType = () => {
  return request({
    method: 'GET',
    url: `${basePrefix}/commonAuth/getApplicationTypeList`,
    params: {
      applyTypeCode: 'export_product_certificate'
    }
  })
}

// 获取业务类型下的子类
export const getApplicationTypeItem = (id: any) => {
  return request({
    method: 'GET',
    url: `${basePrefix}/commonAuth/getApplicationTypeItemsList/${id}`
  })
}
// 日志列表
export const getLogList = (params: string) => {
  return request({
    method: 'GET',
    url: `${urlPrefixIraq}/rfcProcess/getList?cargoRfcId=${params}`
  })
}
// *************************业务类型 end***********************************

// **************************沙特申请单start************************************
// 获取申请列表
export const getRfcList = (params: any) => {
  return request({
    method: 'GET',
    url: `${urlPrefix}/rfc/list`,
    params
  })
}
// 获取产品分类
export const getProductKingList = () => {
  return request({
    method: 'GET',
    url: `${urlPrefix}/rfcProductKing/list`,
    params: {
      pageNum: 1,
      pageSize: 100
    }
  })
}
// 受理
export const onAcceptRef = (id: number, data: any) => {
  return request({
    method: 'POST',
    url: `${urlPrefix}/rfc/accept/${id}`,
    data
  })
}
// 调单、暂停、恢复暂停
export const setRfcStatus = (id: number, data: any) => {
  return request({
    method: 'POST',
    url: `${urlPrefix}/rfc/jumpStatus/${id}`,
    data
  })
}
// 订单标记与取消
export const setRfcPriority = (id: any, isPriority: number) => {
  return request({
    method: 'POST',
    url: `${urlPrefix}/rfc/updateRfcFields/${id}`,
    data: {
      isPriority // 是否优先处理，1是 0不是
    }
  })
}
// 新建订单
export const createRfc = (data: any) => {
  return request({
    method: 'POST',
    url: `${urlPrefix}/rfc/addRfc`,
    data
  })
}

// 历史进口商商、制造商等列表
export const getRfcCompanyList = (params: any) => {
  return request({
    method: 'GET',
    url: `${urlPrefix}/rfcCompany/list`,
    params
  })
}

/*
* 查询申请单详情
*/
export const getApplicationDetails = (id: any) => {
  return request({
    method: 'GET',
    url: `${urlPrefix}/rfc/${id}`
  })
}

// 获取申请单excel数据
export const getApplicationExcel = (data: any) => {
  return request({
    method: 'POST',
    url: `${urlPrefixIraq}/rfc/excelImport`,
    data
  })
}

// **************************申请中的单据************************************
// 获取申请中的单据列表
// 获取申请列表
export const getDraftList = (params: any) => {
  return request({
    method: 'GET',
    url: `${urlPrefix}/rfc/draft/list`,
    params
  })
}
/*
 * 删除申请草稿
 */
export const deleteRfc = (id: any) => {
  return request({
    method: 'DELETE',
    url: `${urlPrefix}/rfc/${id}`
  })
}

// **************************暂停订单************************************
// 暂停订单列表
export const getRfcSuspendList = (params: any) => {
  return request({
    method: 'GET',
    url: `${urlPrefix}/rfc/suspend/list`,
    params
  })
}

// ******************  恢复附件  *******************************
// 恢复附件列表
export const queryRestoreFileList = (id: any) => {
  return request({
    method: 'GET',
    url: `${urlPrefixIraq}/rfcFile/regainFileList`,
    params: { cargoRfcId: id }
  })
}
// 恢复文件
export const restoreFile = (id: any) => {
  return request({
    method: 'POST',
    url: `${urlPrefixIraq}/rfcFile/regainFile`,
    data: {
      id
    }
  })
}
// 一键下载附件
export const oneClickDownload = (data: any) => {
  return request({
    method: 'POST',
    url: `${urlPrefixIraq}/rfcFile/exportZIP`,
    data,
    responseType: 'blob'
  })
}
// 新增附件--Java
export const addFile = (data: any) => {
  return request({
    method: 'POST',
    url: `${urlPrefixIraq}/rfcFile/save`,
    data
  })
}
// 申请中单据列表
export const getDocumentList = (data: any) => {
  return request({
    method: 'GET',
    url: `${urlPrefixIraq}/rfc/getDocumentList`,
    params: data
  })
}
// ****************** 基础信息  *******************************
